/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpgradeDeploymentStatusEnum } from './upgradeDeploymentStatusEnum';


export interface UpgradeInfo { 
    cdvx_ami_id?: string;
    cdvx_ami_name: string;
    /**
     * Creation/Trigger date for the Deployment
     */
    deployed_date?: Date;
    irr_ami_id?: string;
    irr_ami_name: string;
    lambda_zip_file_name: string;
    status: UpgradeDeploymentStatusEnum;
    /**
     * User who upgraded the deployment.
     */
    upgraded_by: string;
    version: string;
}
export namespace UpgradeInfo {
}


